import { Router } from '@angular/router';
// RxJS
import { Observable, combineLatest } from 'rxjs';
import { tap, take } from 'rxjs/operators';
// NGRX
import { select, Store } from '@ngrx/store';
import { isLoggedIn, authRole } from '../_selectors/auth.selectors';
import { Logout } from '../_actions/auth.actions';
import { ENUM } from '../../enum/enum';
var AdminGuard = /** @class */ (function () {
    function AdminGuard(store, router) {
        this.store = store;
        this.router = router;
    }
    AdminGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            combineLatest(_this.store.pipe(select(isLoggedIn)), _this.store.pipe(select(authRole))).pipe(tap(function (_a) {
                var loggedin = _a[0], authRole = _a[1];
                if (!loggedin) {
                    _this.router.navigateByUrl('/auth/login');
                }
                else if (authRole && +authRole != ENUM.roles.ADMIN) {
                    if (+authRole == ENUM.roles.CASHIER) {
                        _this.router.navigateByUrl('/cashier');
                    }
                    else if (+authRole == ENUM.roles.FINANCIAL) {
                        _this.router.navigateByUrl('/cashier-management/shifts');
                    }
                    else if (+authRole == ENUM.roles.OPERATION) {
                        _this.router.navigateByUrl('/queue-management/requests');
                    }
                    else if (+authRole == ENUM.roles.AIRPORT) {
                        _this.router.navigateByUrl('/dashboard');
                    }
                    else {
                        _this.store.dispatch(new Logout());
                    }
                }
            })).pipe(take(1)).subscribe(function () { return resolve(true); });
        });
    };
    return AdminGuard;
}());
export { AdminGuard };
